import { httpClient } from './httpClient'
import { PATH_LOGIN } from './pathConstants'

export const login = async (username: string, password: string) =>
  await httpClient.post(PATH_LOGIN, { username, password })
